<template>
    <div class="payments">
        <Navbar />
        <div class="mt-5 pt-5 kova-width">
            <div class="text-left pl-0 pl-md-5 mt-3 ml-5 mb-4">
                <a-icon class="mr-1" type="arrow-left" /> <span class="go-back">Go Back</span>
            </div>
            <div class="px-1 px-md-4 px-lg-5 mx-lg-4 my-5">
                <div class="bg-light border p-2 p-md-4">
                    <h5 class="font-weight-bolder text-left">Billing and Payments</h5>
                    <h6 class="text-left mt-4">Current Balance</h6>
                    <h6 class="font-weight-bolder text-left">Your balance is $120.00</h6>
                </div>
                <div class="mx-3 add-rounded">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-7 bg-light">
                            <div class="row">
                                <div class="col-12 col-md-12 col-lg-11 border border-top-0">
                                    <div class="my-4">
                                        <div class="d-flex">
                                            <div class="text-left mr-auto">
                                                <h6 class="font-weight-bolder text-left">Withdrawal</h6>
                                            </div>
                                            <div class="">
                                                <div class="input-group mb-3">
                                                    <input
                                                        type="button"
                                                        value="Add a new bank"
                                                        class="btn-kovatek new-bank py-1 px-3"
                                                    />
                                                    <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                                        <a-icon type="plus" style="position: relative;bottom: -3px;" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="px-1 px-md-3 ">
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">
                                                Account Name
                                            </h6>
                                            <a-input
                                                size="large"
                                                class="ml-1 font-weight-bolder"
                                                v-model="accountName"
                                            />
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">
                                                Account Number
                                            </h6>
                                            <a-input
                                                size="large"
                                                class="ml-1 font-weight-bolder"
                                                v-model="accountNumber"
                                            />
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">
                                                Bank Name
                                            </h6>
                                            <a-input size="large" class="ml-1 font-weight-bolder" v-model="bankName" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-lg-1 bg-white"></div>
                            </div>
                        </div>

                        <div class="col-12 col-md-12 col-lg-5 bg-light border border-top-0">
                            <div class="px-1 px-md-3 ">
                                <h6 class="font-weight-lighter text-left ml-2 mt-3">
                                    How much do you want to withdraw?
                                </h6>
                                <a-input size="large" type="number" class="ml-1 font-weight-bolder" />
                                <h6 class="font-weight-lighter text-left ml-2 mt-3">Kovatek Password</h6>
                                <a-input size="large" type="password" class="ml-1 font-weight-bolder" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';

export default {
    name: 'payments',
    components: {
        Navbar,
        Footers,
    },
    data() {
        return {
            accountName: 'Johnson Kolawole',
            accountNumber: '0093456783',
            bankName: 'United Bank for Africa',
        };
    },
};
</script>

<style scoped>
.kova-width {
    max-width: 1350px;
    margin: auto;
}
.new-bank {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.plus-btn-icon {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: solid 1px #fff;
}
.ctrl-font {
    font-size: 12px;
}
</style>
